export const VIDEO_ASSET_ID_RE = /^asset-[A-Za-z0-9-]+$/;
export const VIDEO_ASSET_STATUSES = ['active', 'processing', 'failed'];

// Trim and drop a leading "asset://".
export const normalizeVideoAssetId = (raw) => String(raw || '').trim().replace(/^asset:\/\//i, '').trim();

export const isValidVideoAssetId = (raw) => VIDEO_ASSET_ID_RE.test(normalizeVideoAssetId(raw));

// Asset id to send for this source video: only when valid, Active, and recorded for the same video.
export const resolveVideoAssetIdForRequest = (record, sourceVideo) => {
    if (!record || (record.sourceVideo && sourceVideo && record.sourceVideo !== sourceVideo)) return null;
    const id = normalizeVideoAssetId(record.assetId);
    if (!VIDEO_ASSET_ID_RE.test(id)) return null;
    return String(record.status || '').toLowerCase() === 'active' ? id : null;
};

const REAL_PERSON_BLOCK = 'BytePlus blocked the source video because it shows a real person';
export const friendlyEditError = (message) => (String(message || '').includes(REAL_PERSON_BLOCK)
    ? 'This video shows a real person. Add its BytePlus video asset ID and try again.'
    : message);
